import { render, staticRenderFns } from "./WcModal.vue?vue&type=template&id=79a47842&scoped=true"
import script from "./WcModal.vue?vue&type=script&lang=js"
export * from "./WcModal.vue?vue&type=script&lang=js"
import style0 from "./WcModal.vue?vue&type=style&index=0&id=79a47842&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a47842",
  null
  
)

export default component.exports